import { Licenses } from "../Data/Licenses.ts"
import { useParams } from "../Providers/ParamsProvider"

const useCheckLicense = () => {
    const { license, handleGetLicense } = useParams()
    // const license = params?.license ? params.license : localStorage.getItem("APP_LICENSE")

    const checkLicense = async (allowedLicenses: Licenses[]): Promise<boolean> => {
        if (!license || license.trim() === "") {
            var downloaLicense = await handleGetLicense()
            if (!downloaLicense || downloaLicense.trim() === "") {
                return false
            }
        }
        if (license === Licenses.Ferrodo) { //wszystkie opcje dla ferrodo
            return true
        }
        var tmpLicense = downloaLicense?.trim() === '' ? license : downloaLicense

        return allowedLicenses.includes(tmpLicense as Licenses)
    }

    return { checkLicense }
}

export default useCheckLicense